export const MEMBER_DEDUCTIBLE_OR_EMBEDDED_DEDUCTIBLE = 'MEMBER_DEDUCTIBLE_OR_EMBEDDED_DEDUCTIBLE';
export const PLAN_DEDUCTIBLE_OR_EMBEDDED_DEDUCTIBLE = 'PLAN_DEDUCTIBLE_OR_EMBEDDED_DEDUCTIBLE';
